// extracted by mini-css-extract-plugin
export default {"agenda":"w37j00gq","logo":"d3ua_3SR","mobile":"mobile"};